import React, { useEffect, useRef, useState } from 'react';
import { Card, Button, Row, Col, Upload, Modal, Form, message } from 'antd';
import './works.scss';
import EditIcon from '../../../../src/assets/images/edit_icon.svg';
import { useLocation } from 'react-router-dom';
import deleteIcon from '../../../assets/images/delete_icon_white.svg'
import { useDispatch, useSelector } from 'react-redux';
import { getWorks, addWorks, deleteWorks } from '../../../slices/works/thunk';
import { Spin } from 'antd/lib';
import NoResults from '../../Components/NoResults/NoResults';
import { getVerifiedStatus } from '../../../Services/LocalStorageService';
import Log from '../../../Services/Log';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ShimmerSimpleGallery } from "react-shimmer-effects";
import MobileView from '../MobileView/MobileView';
import { getDashboard } from '../../../slices/dashboard/thunk';
import { WorkStatus } from '../../../Services/AdsStatusService';
import ProfileNotVerifiedPopup from '../../../Common/profileNotVerifiedPopup/ProfileNotVerifiedPopup';
import { Popup_Toast } from '../../../constants/Popups_Toast';




const Works = () => {
    document.title = "Works";

    const uploadRef = useRef(null);
    const storeData = (state) => {
        // console.log("Redux Store State:", state); 
        return {
            work: state.Account.user,
        };
    };
    let worksData = useSelector((state) => state.Works);
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    let popupContent = Popup_Toast;




    let selectedImagesLength = 0;
    let adminVerificationStatus = useSelector((state) => state.Dashboard?.adminVerificationStatus);
    const [loading, setLoading] = useState(false);
    const [checked, setChecked] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);
    const [deleteBtn, setDeleteBtn] = useState(false);
    const [selectedTemporary, setSelectedTemporary] = useState([]);
    const [uploadButton, setUploadButton] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [errorModal, setErrorModal] = useState(false);
    const [errorVerificationModal, setErrorVerificationModal] = useState(false);
    const [fileName, setFileName] = useState('');
    const [imagesUrl, setImagesUrl] = useState([]);
    const [blinkElement, setBlinkElement] = useState(false);
    const [worksNum, setWorksNum] = useState(false);
    const [imagesUpload, setImagesUpload] = useState([]);
    const [imagePreviews, setImagePreviews] = useState([]);
    const [status, setStatus] = useState(false);
    const [fileList, setFileList] = useState([])
    const [worksItems, setWorksItems] = useState([]);
    const [previewWorksItems, setPreviewWorksItems] = useState([]);
    const [triggerUpdate, setTriggerUpdate] = useState(false)
    // infinite scroll
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(1);
    const limit = 30;
    const [mobilePreview, setMobilePreview] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    const [profileNotVerifiedModal, setProfileNotVerifiedModal] = useState(false);
    const [previewBg, setPreviewBg] = useState(false);
    const [triggerWorkEvents, setTriggerWorkEvents] = useState(false);
    const [previewModal, setPreviewModal] = useState(false)

    useEffect(() => {
        dispatch(getDashboard());
    }, [])
    const showModal = () => {
        setIsModalOpen(true);
    };
    const fetchMoreData = () => {
        if (loading || !hasMore) return;  // Prevent multiple fetches

        setLoading(true);  // Set loading to true to prevent multiple fetches
        setPage(prevPage => prevPage + 1); // Increase the page number
    };
    const handleOk = async () => {
        console.log(selectedImages);
        setIsModalOpen(false);
        setSelectedTemporary([]);
        setSelectedImages([]);
        setChecked(prev => !prev);

        const worksElements = selectedImages.map(image => image._id).filter(id => id !== undefined);
        console.log('selected images to be deleted', worksElements);

        try {
            setLoading(true);

            let response = await dispatch(deleteWorks(worksElements));
            if (response?.meta?.requestStatus === 'fulfilled') {
                setTriggerWorkEvents((prev) => !prev)
            }
            setDeleteBtn(false);
        } catch (error) {
            console.error("Error updating catalog:", error);
        } finally {
            setLoading(false);
        }
        setSelectedImages([]);
    };



    const handleCancel = () => {
        setIsModalOpen(false);
        setErrorModal(false);
        setErrorVerificationModal(false);
        setPreviewModal(false)
        setImagesUpload([]);
        setFileList([]);
        setLoading(false)
    };

    const handleRemove = (file) => {
        setSelectedImages((prevSelected) =>
            prevSelected.filter((item) => item.file.uid !== file.uid)
        );
        if (selectedImages.length === 0) {
            message.info('All images have been removed');
            setUploadButton(false);
        }
    };
    const handleImageClick = (image) => {
        setSelectedTemporary(prevSelected => [...prevSelected, image]);
        if (checked) {
            setSelectedImages(prevSelected => {
                const newSelectedImages = prevSelected.includes(image)
                    ? prevSelected.filter(img => img !== image)
                    : [...prevSelected, image];
                setUploadButton(newSelectedImages.length > 0);
                return newSelectedImages;
            });
        }
    };

    // cropped image handle
    const data = async (value, src) => {
        setImagesUpload([...imagesUpload, src]);
        setImagePreviews([...imagesUpload, src])
    };
    const uploadImages = async () => {

        if (imagesUpload.length > 0) {
            setUploading(true);

            try {
                const uploadPromises = imagesUpload.map((el) => dispatch(addWorks([el?.base64])));
                const responses = await Promise.all(uploadPromises);

                const allFulfilled = responses.every(
                    (response) => response?.meta?.requestStatus === 'fulfilled'
                );

                if (allFulfilled) {
                    setTriggerWorkEvents((prev) => !prev);
                    message.success('Images uploaded successfully!');
                } else {
                    message.error('Some images failed to upload. Please try again.');
                }
            } catch (error) {
                console.error('Error uploading images:', error);
                message.error('Error uploading images. Please try again later.');
            } finally {
                setUploading(false);
                setLoading(false);
                setImagesUpload([]);
                setFileList([]);
                dispatch(getWorks({ page: 1, limit }));
                setTriggerUpdate(true);
            }
        }

    };





    const handleBeforeUpload = (file) => {
        setWorksNum(false);

        // Check if the file list already has 5 files
        if (fileList.length >= 4) {
            message.error("You can only upload up to 4 images.");
            return Upload.LIST_IGNORE; // Prevents the file from being added to the list
        }

        // Check if the file size is less than 1MB
        const isLt5M = file.size / 1024 / 1024 <= 5;
        if (!isLt5M) {
            message.error('Image must be smaller than 5MB!');
            return Upload.LIST_IGNORE;
        }

        // Truncate the file name if it’s too long and set state
        const truncatedName = file.name.length > 20 ? file.name.slice(0, 20) + '...' : file.name;
        setFileName(truncatedName);

        // Update the state to enable the upload button
        setUploadButton(true);

        // Allow the file to be added to the upload list
        return true;
    };

    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    };
    let flag = true;

    const handleChange = ({ fileList: newFileList }) => {
        if (newFileList?.length <= 4) {
            setLoading(true)
            setFileList(newFileList.slice(0, 4));
        }
        else {
            setLoading(false)
            if (flag) {
                message.error("You can only upload up to 4 images.");
                flag = false;
            }
            setFileList(newFileList.slice(0, 4));
        }
        // if (info.file.status === 'done') {
        //     setUploading(false);
        //     const fileData = info.file;
        //     setImagePreviews((prev) => [
        //         ...prev,
        //         { uid: fileData.uid, url: fileData.thumbUrl || '' },
        //     ]); // Update image previews with new files
        // } else if (info.file.status === 'error') {
        //     setUploading(false);
        //     message.error(`${info.file.name} file upload failed.`);
        // }
    };
    const removeFromPreview = (file) => {
        setFileList((prevFileList) => prevFileList.filter((item) => item.uid !== file.uid));
    };
    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }
        const imgWindow = window.open(file.preview);
        imgWindow.document.write(`<img src="${file.preview}" loading="lazy" />`);
    };




    const imageUpload = (file) => {
        if (!file || !file.name) {
            console.error(file.name);
            return;
        }
    };

    const showStatusModal = () => {
        if (status === 'false') {
            setProfileNotVerifiedModal(prev => !prev)
        }
        else {
            setErrorVerificationModal(false)
        }
    }



    const handleDeleteSelectedImage = (image) => {
        setSelectedImages(prevSelected => {
            const newSelectedImages = prevSelected.filter(img => img !== image);
            setUploadButton(newSelectedImages.length > 0);
            return newSelectedImages;
        });
    };

    useEffect(() => {
        // console.log('works data ' , worksData)
        if (worksData?.data?.length === 0) {
            setWorksNum(true)
        }
    }, [worksData])

    selectedImagesLength = selectedImages.length

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [pathname]);


    // Infinite scroll

    // useEffect(() => {
    //     dispatch(getWorks({ page: page, limit: limit }));
    //     setStatus(getVerifiedStatus)
    // }, [page])

    useEffect(() => {
        dispatch(getWorks({ page, limit })).then(() => {
            setLoading(false);  // Set loading to false after fetching
        });
        setStatus(getVerifiedStatus)
    }, [page]);

    useEffect(() => {
        if (worksData.data) {
            setWorksItems(prevItems => {
                if (page === 1) {
                    return worksData.data;
                } else {
                    const newItems = worksData.data.filter(
                        newItem => !prevItems.some(prevItem => prevItem._id === newItem._id)
                    );
                    return [...prevItems, ...newItems];
                }
            });
        }
        if (worksItems?.length < limit || worksItems?.length === 0) {
            setHasMore(false);
        }
    }, [worksData]);


    useEffect(() => {
        if (adminVerificationStatus) {
            setStatus(adminVerificationStatus)
        }
    }, [adminVerificationStatus])

    useEffect(() => {
        if (!worksData.loading) {
            setInitialLoading(false);
        }
    }, [worksData.loading]);


    useEffect(() => {
        if (fileList?.length === 0) {
            setPreviewBg(false)
        }
        else {
            // setPreviewBg(true);
            imageConversion()
        }
    }, [fileList])

    useEffect(() => {
        if (imagesUpload?.length !== 0) {
            setLoading(false)
            setPreviewModal(true)
        }
        else {
            setPreviewModal(false)
            setFileList([]);
        }
    }, [imagesUpload])

    function imageConversion() {

        if (fileList !== 0 || fileList !== undefined) {
            const processFiles = async () => {
                const base64Array = await Promise?.all(
                    fileList?.map(async (file) => {
                        const base64 = await convertToBase64(file.originFileObj);
                        return { uid: file.uid, base64 }; // Store both uid and base64
                    })
                );
                setImagesUpload(base64Array); // Set the array of objects with uid and base64
            };
            const convertToBase64 = (file) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = error => reject(error);
                });
            };
            processFiles();
        }
    }

    const previewDelete = (id) => {
        let updatedPreview = imagesUpload?.filter((el) => el?.uid !== id);
        setImagesUpload(updatedPreview)
    }

    useEffect(() => {
        if (Array.isArray(worksItems) && worksItems.length > 0) {
            const filteredItems = worksItems.filter(el => el?.verification_status !== 2);
            setPreviewWorksItems(filteredItems);
        }
    }, [worksItems]);

    return (
        <>
            <div className={`dark_overlay ${previewBg}`}></div>
            <div className={`parent_wrap`}>

                {
                    (loading || (worksData.loading && initialLoading)) && (
                        <div className="spinner center" key={0}>
                            <Spin />
                        </div>
                    )
                }

                {/* {
                    (worksData.loading && initialLoading) && (
                        <ShimmerSimpleGallery card item={2} imageHeight={240} caption className="basic_shimmer_holder" />
                    )
                } */}
                {/* {
                    (worksData.loading ) && (
                        <div className="spinner center" key={0}>
                            <Spin />
                        </div>
                    )
                } */}
                <InfiniteScroll
                    dataLength={worksItems?.length}
                    next={fetchMoreData}
                    hasMore={hasMore}
                    loader={
                        worksData.loading && (
                            <div className="spinner center" key={0}>
                                <Spin />
                            </div>
                        )
                    }

                // endMessage={<p className='no_more_text'>No more items to load</p>}

                >
                    <Button className={`mobile_preview_toggle ${mobilePreview && 'active'}`} onClick={() => {
                        setMobilePreview((prev) => !prev)
                    }}>
                        <figure>
                            <svg xmlns="http://www.w3.org/2000/svg" width="62.138" height="63.9" viewBox="0 0 62.138 63.9">
                                <g id="Group_1" data-name="Group 1" transform="translate(-4 -3)">
                                    <path id="Path_1" className='svg-path' data-name="Path 1" d="M65,33.9a42.465,42.465,0,0,0-12.3-9.5V11.5A8.493,8.493,0,0,0,44.2,3H12.5A8.493,8.493,0,0,0,4,11.5V58.4a8.493,8.493,0,0,0,8.5,8.5H44.3a8.493,8.493,0,0,0,8.5-8.5V48.8a42.152,42.152,0,0,0,12.3-9.5A3.9,3.9,0,0,0,65,33.9ZM34.7,8.1l-1.2,3.8H23.2L22,8.1Zm13,50.4A3.543,3.543,0,0,1,44.2,62H12.4a3.543,3.543,0,0,1-3.5-3.5v-47A3.543,3.543,0,0,1,12.4,8h4.2l1.9,5.8a4.416,4.416,0,0,0,4.2,3H33.9a4.416,4.416,0,0,0,4.2-3L40,8.1h4.2a3.543,3.543,0,0,1,3.5,3.5v11a3.553,3.553,0,0,0-1-.2c-.3-.1-.6-.1-.9-.2a5.019,5.019,0,0,0-1.2-.2,1.268,1.268,0,0,1-.6-.1c-.6,0-1.1-.1-1.7-.1h-.1c-10.7,0-19.5,8.4-22.7,12.1a4.126,4.126,0,0,0,0,5.5c3.3,3.6,12,12,22.7,12h.3a7.084,7.084,0,0,0,1.4-.1,1.7,1.7,0,0,0,.7-.1c.3,0,.6-.1.9-.1.6-.1,1.2-.2,1.7-.3a.367.367,0,0,0,.3-.1v7.8ZM49,45c-.4.2-.9.3-1.3.5-.1,0-.3.1-.4.1-.5.1-.9.3-1.4.4a.367.367,0,0,0-.3.1c-.5.1-1.1.2-1.6.3h-.1a9.7,9.7,0,0,1-1.7.1c-8.3,0-15.6-6.8-18.4-9.7C26.6,33.9,33.9,27,42.2,27a8.6,8.6,0,0,1,1.6.1.756.756,0,0,1,.4.1c.4.1.9.1,1.3.2.2,0,.3.1.5.1l1.2.3c.2.1.4.1.6.2.4.1.7.3,1.1.4,5.4,2.1,9.8,6.3,11.8,8.4-2,2-6.4,6.1-11.7,8.2Z" fill="#ef6f6f" />
                                    <path id="Path_2" className='svg-path' data-name="Path 2" d="M46.1,35.1a2.506,2.506,0,0,0-.4-.7,4.313,4.313,0,0,0-1.1-1.1c-.2-.1-.5-.3-.7-.4a1.884,1.884,0,0,0-.8-.2,4.165,4.165,0,0,0-3.7,1.1,4,4,0,0,0-1.2,2.9,3.847,3.847,0,0,0,1.2,2.9,4,4,0,0,0,2.9,1.2,2.2,2.2,0,0,0,.8-.1,2.353,2.353,0,0,0,.8-.2,2.506,2.506,0,0,0,.7-.4,2.651,2.651,0,0,0,.6-.5,4,4,0,0,0,1.2-2.9,2.2,2.2,0,0,0-.1-.8A1.884,1.884,0,0,0,46.1,35.1Z" fill="#ef6f6f" />
                                </g>
                            </svg>
                        </figure>
                    </Button>
                    <section className="works_block content_mobileView_wrap block">
                        <Card >
                            {worksData?.data?.length === 0 && <span className='sm text_gray note_without_ad'><strong>Note : </strong>You can upload up to 4 images at a time.
                            </span>}
                            <div className="title_wrap" style={{ display: "flex", alignItems: "center", marginBottom: "calc(30px + .7vw)", justifyContent: "space-between" }}>
                                <div className="title" style={{ display: "flex", alignItems: "center" }}>

                                </div>

                                <div className='upload_wrap'>

                                    {worksData?.data?.length > 0 && (
                                        <>
                                            <div className='works_notes_wrap'>
                                                <h4 className='text_md' style={{ marginBottom: "0", fontWeight: '500' }}>Uploaded Works</h4>
                                                <span className='sm text_gray'><strong>Note : </strong>You can upload up to 4 images at a time.
                                                </span>
                                            </div>
                                            <div className="cancel_wrap">
                                                {checked ? (
                                                    <>
                                                        <Button className="cancel_btn edit_btn" style={{ marginLeft: "22px", transition: 0 }} onClick={() => {
                                                            setChecked(prev => !prev);
                                                            setDeleteBtn(false);
                                                        }}>Cancel</Button>
                                                    </>
                                                ) : (
                                                    <Button style={{ height: "45px", transition: 0, padding: 0 }} className='default_remove' type="dashed" onClick={() => {
                                                        setChecked(prev => !prev);
                                                        setSelectedImages([]);
                                                        setDeleteBtn(true);
                                                        setUploadButton(false);
                                                    }}><img src={EditIcon} alt="" loading="lazy" />
                                                    </Button>
                                                )}
                                            </div>
                                        </>
                                    )}
                                    {
                                        deleteBtn ?
                                            <Button className="delete_btn" type='primary' onClick={() => {
                                                if (selectedImages.length === 0) {
                                                    setErrorModal(true);
                                                }
                                                else {
                                                    showModal();
                                                }
                                            }}>Delete</Button>
                                            :
                                            <div className={`picture_upload ${worksData?.data?.length > 0 && 'active'}`}>
                                                <Form style={{ display: "flex", alignItems: "center", }} className='works_upload'>
                                                    <Form.Item
                                                        style={{ marginBottom: 0 }}
                                                        name="img_upload"
                                                        valuePropName="fileList"
                                                        getValueFromEvent={e => Array.isArray(e) ? e : e && e.fileList}
                                                    >

                                                        <Button
                                                            style={{ marginBottom: 0 }}
                                                            type='primary'
                                                            className={`works_add short ${worksNum ? 'blink' : ''}`}
                                                        // onClick={() => {
                                                        //     showStatusModal();
                                                        // }}
                                                        >
                                                            + Add
                                                            <div className='preview_wrap'>
                                                                <Upload
                                                                    accept=".jpeg,.jpg,.png"
                                                                    className='custom_upload_images '
                                                                    multiple
                                                                    fileList={fileList}
                                                                    onPreview={handlePreview}
                                                                    onChange={handleChange}
                                                                    beforeUpload={handleBeforeUpload} // Use handleBeforeUpload for validation
                                                                    listType="picture-card"
                                                                    onRemove={removeFromPreview}

                                                                >
                                                                    <div>
                                                                        +
                                                                        <div style={{ marginTop: 8 }}>Upload</div>
                                                                    </div>
                                                                </Upload>

                                                                {/* <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: 16 }}>
                                                                {imagePreviews.map((image) => (
                                                                    <div key={image.uid} style={{ marginRight: 8, marginBottom: 8 }}>
                                                                        <Image
                                                                            width={100}
                                                                            src={image.url}
                                                                            alt="preview"
                                                                            style={{ borderRadius: 4, objectFit: 'cover' }}
                                                                        />
                                                                    </div>
                                                                ))}
                                                            </div> */}

                                                                {/* <Button
                                                            type="primary"
                                                            onClick={() => {
                                                                console.log('Files submitted:', fileList);
                                                            }}
                                                        >
                                                            Submit
                                                        </Button> */}
                                                            </div>
                                                        </Button>
                                                        {/* <Button
                                                            
                                                            type='primary'
                                                            className={`image_upload_btn ${fileList.length > 0 ? 'active' : ''}`}
                                                            disabled={fileList.length === 0}
                                                        >
                                                            Upload
                                                        </Button> */}
                                                    </Form.Item>

                                                    {/* {uploadButton && (
                                            <Button
                                                type="primary"
                                                onClick={handleSubmit}
                                                style={{ marginLeft: "10px" }}
                                                disabled={uploading}
                                            >
                                                {uploading ? 'Uploading...' : 'Submit'}
                                            </Button>
                                        )} */}
                                                </Form>
                                            </div>
                                    }
                                </div>
                            </div>
                            <div className={`gallery ${checked ? "selection_active" : ""}`}>
                                <Row align="middle" gutter={[20, 20]}>
                                    {worksData && worksItems?.length > 0 ? (
                                        worksItems?.map((el, index) => {
                                            const isActive = selectedImages.includes(el);
                                            return (
                                                <Col key={index} xs={12} md={8} lg={6} xl={4} className='work_holder' >
                                                    <div className={`img_body custom_shadow red_shadow ${WorkStatus(el?.verification_status)} ${isActive ? 'active' : ''}`} onClick={() => handleImageClick(el)}>
                                                        <img src={el.original} alt="" className='img_full cover' loading="lazy" />
                                                        <span className="selected" style={{ '--i': index }}></span>
                                                        <span className="position_center"><span className='text_md'>Verification</span> <span className='semibold text_lg2'>{
                                                            WorkStatus(el?.verification_status)
                                                        }</span></span>
                                                    </div>

                                                </Col>
                                            );
                                        })
                                    ) : (
                                        !worksData.loading && (
                                            <NoResults
                                                type={'works'}
                                                title={'Upload Your Works'}
                                                description={'Upload your top works to engage more customers. These images will be highlighted on your business page for all to see!'}>
                                            </NoResults>
                                        )
                                    )}
                                </Row>

                            </div>
                            {/* {selectedImages.length > 0 && (
                        <div className="selected_images_list">
                            <h4>Selected Images:</h4>
                            <Row align="middle" gutter={[20, 20]}>
                                {selectedImages.map((image, index) => (
                                    <Col key={index} xs={12} md={12} lg={4}>
                                        <div className="selected_image">
                                            <img src={image.src} alt="" className="img_full cover" />
                                            <p>{image.name}</p>
                                            <Button onClick={() => handleDeleteSelectedImage(image)}>Delete</Button>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    )} */}
                            <Modal afterClose={() => (document.body.style.overflow = 'initial')} className='sm_modal work_modal center_modal' open={isModalOpen} footer={[
                                <div className='md'><Button key="submit" type="primary" className='short wide' onClick={handleOk}>
                                    Continue
                                </Button>
                                    <Button key="close" type="text" className="short custom_btn" onClick={handleCancel}>
                                        Close
                                    </Button>
                                </div>,
                            ]} onCancel={handleCancel}>
                                <div className="modal_cnt">
                                    <h2 className='text_lg text_red'>{popupContent?.DELETE_IMAGE?.content?.title}</h2>
                                    <p className='md'>
                                        {popupContent?.DELETE_IMAGE?.content?.description} {selectedImagesLength !== 1 && selectedImagesLength} image
                                        {selectedImagesLength !== 1 ? 's' : ''}?
                                    </p></div>
                            </Modal>
                            <Modal
                                afterClose={() => (document.body.style.overflow = 'initial')}
                                open={errorModal}
                                afterClose={() => (document.body.style.overflow = 'initial')}
                                className='sm_modal work_modal center_modal'
                                onOk={handleCancel}
                                onCancel={handleCancel}
                                footer={[
                                    <Button key="close" type="text" className="short custom_btn" onClick={handleCancel}>
                                        Close
                                    </Button>
                                ]}
                            >
                                <h2 className="text_lg text_red regular">Delete Image
                                </h2>
                                <p className='md'>
                                    Please select at least one image to delete.
                                </p>
                            </Modal>
                            <Modal
                                afterClose={() => (document.body.style.overflow = 'initial')}
                                open={previewModal}
                                afterClose={() => (document.body.style.overflow = 'initial')}
                                className='sm_modal preview_modal work_modal center_modal'
                                onCancel={handleCancel}
                                footer={[
                                    <div className='text-center'>
                                        <Button key="close" type="text" className="short custom_btn" onClick={handleCancel}>
                                            Close
                                        </Button>
                                        <Button key="close" type="primary" className="short wide" onClick={() => {
                                            setLoading(true)
                                            uploadImages();
                                        }}>
                                            Upload
                                        </Button>
                                    </div>
                                ]}
                            >
                                <div className="cnt">
                                    <h2 className="text_lg text_red regular">Upload Photos
                                    </h2>
                                    <p className='md'>
                                        Please confirm the images and upload them to your Works.
                                    </p>
                                    <ul className="preview_list">
                                        {imagesUpload?.map((el) => {
                                            return <li key={el.uid} className='red_shadow'>
                                                <div className="cnt">
                                                    <button onClick={() => {
                                                        previewDelete(el?.uid)
                                                    }}><img src={deleteIcon} alt="" /></button>
                                                    <img src={el?.base64} alt="" />
                                                </div>
                                            </li>
                                        })}
                                    </ul>
                                </div>

                            </Modal>
                            {/* <Modal
                            open={errorVerificationModal}
                            title="Verification Status"
                            onOk={handleCancel}
                            onCancel={handleCancel}
                            footer={[
                                <Button key="submit" type="primary" onClick={handleCancel}>
                                    OK
                                </Button>,
                            ]}
                        >
                            {status ? 'Verification status is OK.' : 'Verification status failed. Please verify your account before uploading images.'}
                        </Modal> */}
                        </Card>
                        <ProfileNotVerifiedPopup status={profileNotVerifiedModal} />
                        <MobileView className={mobilePreview && 'active'} type={'withoutText'} active='3' workTrigger={triggerWorkEvents} updatedWorksData={previewWorksItems} />
                    </section>
                </InfiniteScroll>
            </div>
        </>
    );
}

export default Works;